module.exports = __webpack_public_path__ + "img/bezier-curve.130195dd.svg";